module.exports = __webpack_public_path__ + "img/kaiping.16cd22d1.jpg";